export default {
  establishments: {
    get: {
      title: "Une erreur s'est produite",
      detail: "Les établissements n'ont pas pu être récuperés",
    },
    getById: {
      500: {
        title: "Une erreur s'est produite",
        detail: "Cet établissement n'a pas pu être récuperé",
      },
      404: {
        title: "Une erreur s'est produite",
        detail: "Cet établissement n'existe plus",
      },
    },
    getPotentialByEstablishmentId: {
      title: "Une erreur s'est produite",
      detail: "Les établissements potentiels n'ont pas pu être récuperés",
    },
    rename: {
      title: "Une erreur s'est produite",
      detail: "L'établissement n'a pas pu être renommé",
    },
    merge: {
      title: "Une erreur s'est produite",
      detail: "Les établissements n'ont pas pu être regroupés",
    },
    create: {
      title: "Une erreur s'est produite",
      detail: "Le nouvel établissement n'a pas pu être créé",
    },
    moveSheetsToEstablishment: {
      title: "Une erreur s'est produite",
      detail: "Les fiches n'ont pas pu être déplacées vers l'établissement",
    },
  },
  sheets: {
    getAggregatesByEstablishmentId: {
      title: "Une erreur s'est produite",
      detail: "Les fiches associées à cet établissement n'ont pas pu être récuperées",
    },
  },
};